import { render } from "./CoachDetail.vue?vue&type=template&id=1e671a89"
import script from "./CoachDetail.vue?vue&type=script&lang=js"
export * from "./CoachDetail.vue?vue&type=script&lang=js"
script.render = render

export default script